import { styled } from '@mui/material/styles';

export const StyledActionsWrapper = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const StyledButtonWrapper = styled('div')(({ theme }) => {
  return {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  };
});

export const StyledDesktopOnly = styled('div')(({ theme }) => {
  return {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  };
});
